export function interpolate(input) {
  var formatted = input;
  for (var i = 1; i < arguments.length; i++) {
    var regexp = new RegExp("\\{" + (i - 1) + "\\}", "gi");
    formatted = formatted.replace(regexp, arguments[i]);
  }
  return formatted;
}

export function ReplaceAll(string, target, replacement) {
  let newRegx = new RegExp(target || "", "g");
  return string.replace(newRegx, replacement);
}

export function ConvertToShortHandState(state) {
  switch (state.toLowerCase()) {
    case "victoria":
      return "VIC";
    case "new south wales":
      return "NSW";
    case "queensland":
      return "QLD";
    case "south australia":
      return "SA";
    case "tasmania":
      return "TAS";
    case "western australia":
      return "WA";
    case "australian capital territory":
      return "ACT";
    case "jervis bay territory":
      return "ACT";
    case "northern territory":
      return "NT";
    default:
      return state;
  }
}
export function decodeHtml(html) {
  let txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}
